import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {Button, Dialog} from 'react-weui'
import {Page, Preload, WKError} from '../components'
import '../styles/giftcard/GiftCard.css'
import {renderMoney} from '../utils';
import giftImg from '../images/gift.jpg';
import {browserHistory} from 'react-router'
import qs from 'qs'
import errorImg from '../images/no-source.png'


class GiftCardDetailPage extends React.Component {

    constructor() {
        super();
        this.state = {
            account: '',
            gift: '',
            targetInfo: '',
            subGift: '',
            initialized: false,
            giftDetailType: '',
            showDialog: false,
            buttons: [
                {
                    label: '关闭',
                    onClick: this.hideDialog.bind(this)
                }
            ]
        };

        this.initComponent = this.initComponent.bind(this);
    }

    handleSend(id) {
        const type = this.props.params.type;
        // location.assign(`/account/gift_card_share/${type}/${id}`);
        window.location = `/account/gift_card_share/${type}/${id}`
    }

    hideDialog() {
        this.setState({showDialog: false});
    }

    componentWillUnmount() {
        this.setState({initialized: false});
    }

    componentDidMount() {
        let params = this.props.params
        let giftDetailType = params.type
        let giftDetailId = params.gift_card_detail_id
        let ts = Date.now();

        axios.get('/api/gift/info', {
            params: {
                type: giftDetailType,
                gift_id: giftDetailId,
                ts: ts,
            }
        }).then((response) => {
            if (response.data.code === 0) {
                const {account, gift, target_info, sub_gift, share_info} = response.data.data;
                this.setState({
                    account: account,
                    gift: gift,
                    targetInfo: target_info,
                    subGift: sub_gift,
                    initialized: true,
                    giftDetailType: giftDetailType,
                });

                this.initComponent(share_info);
            }
        }).catch((error) => {
            if (error.response && error.response.status === 404) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '你不是赠礼的创建者。',
                        img: errorImg,
                        href: '/?st=gift_404',
                        btn: '去首页看看'
                    }
                });
            }
        });
    }

    initComponent(share_info) {
        let params = this.props.params
        let type = params.type
        let id = params.gift_card_detail_id

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url,
                successCallback: function () {
                    let data = {type, gift_id: id};
                    axios.post(`/api/gift/share`, qs.stringify(data)).then(res => {
                    })
                }
            }
        });
    }

    render() {
        const {initialized, gift, subGift, targetInfo, account} = this.state;

        const {error} = this.props;
        if (error.showError) {
            return (
                <div className="gift-card-error">
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return <Preload />
        }
        return (
            <Page className="gift-card-detail-page">
                <div className="gift-card-all-div">
                    <div className="gift-card">
                        <div className="gift-card-top">
                            <img src={giftImg} alt="礼物图片"/>
                            <div className="gift-card-describe">
                                <div className="gift-card-describe-title">{account.nickname}买单请你免费听</div>
                                <div>¥{renderMoney(gift.price)}</div>
                            </div>
                            <div className="gift-card-number">{subGift.length}份</div>
                        </div>
                        <div className="bottom-info">
                            <div className="bottom-big-title">{targetInfo.name}</div>
                            <div>{targetInfo.liveroom_name}</div>
                        </div>
                    </div>
                    <div className="gift-receive-detail">
                        <div className="gift-receive-title">赠礼领取明细</div>
                        <div className="gift-receive-list">
                            <ul>
                                <li>编号</li>
                                <li>使用详情</li>
                                <li>发送状态</li>
                            </ul>

                            {subGift.map((item, i) => (
                                <ul key={i} className="gift-item">
                                    <li>{i + 1}</li>
                                    <li>{item.status === 'used' ? item.consumer : '未使用'}</li>
                                    <li>
                                        {item.send_status === 'unsend' ?
                                            <Button className="gift-receive-list-button"
                                                    onClick={this.handleSend.bind(this, item.id)}>
                                                发送
                                            </Button>
                                            :
                                            (
                                                item.status === 'used' ?
                                                    <Button className="gift-receive-list-button sended">已发送</Button>
                                                    :
                                                    <Button className="gift-receive-list-button"
                                                            onClick={this.handleSend.bind(this, item.id)}>已发送</Button>
                                            )
                                        }
                                    </li>
                                </ul>
                            ))}
                        </div>
                    </div>
                    <div className="gift-card-button">
                        <Button onClick={ e => this.setState({showDialog: true}) }>一键分享所有赠礼</Button>
                        <Dialog buttons={this.state.buttons} show={this.state.showDialog}>
                            点击右上角按钮，一键分享所有赠礼
                        </Dialog>
                    </div>
                </div>
            </Page>
        );
    }
}

export default connect(state => ({
    error: state.error,
}))(GiftCardDetailPage)


// WEBPACK FOOTER //
// ./src/pages/GiftCardDetailPage.js